<template>
  <div>
    <div class="payment-profiles-container">
      <card-loading-skeleton v-if="loadingPaymentProfiles" />
      <div
        v-else
        class="payment-profile mr-2 mb-2"
        v-for="cardInfo in paymentProfiles"
        :key="cardInfo.id"
      >
        <!-- Direct Debit -->
        <DirectDebit
          :canManage="canManage"
          :makeAsDefaultPayment="toggleConfirmDialog"
          :isDefault="defaultPaymentProfile"
          v-if="cardInfo.bankName"
          :card="cardInfo"
          :dataTestId="dataTestId"
        />
        <!-- Credit/Debit Card -->
        <card
          v-else
          :canManage="canManage"
          :cardInfo="cardInfo"
          :makeAsDefaultPayment="toggleConfirmDialog"
          :isDefault="defaultPaymentProfile"
          :dataTestId="dataTestId"
        />
      </div>
      <add-payment-method-card
        v-if="!loadingPaymentProfiles && canManage"
        :totalPaymentProfiles="totalPaymentProfiles"
        :dataTestId="dataTestId"
        @toggleAddPaymentProfile="toggleAddPaymentProfileDialog"
      />
      <add-payment-profile-dialog
        :dialogState="dialogState"
        :toggleAddPaymentProfileDialog="toggleAddPaymentProfileDialog"
        :getPaymentProfiles="getPaymentProfiles"
      />
      <default-payment-profile-confirm-dialog
        :dialogState="confirmDialogState"
        :toggleConfirmDialog="toggleConfirmDialog"
        :cardId="cardId"
      />
    </div>
  </div>
</template>
<script>
import { mapState } from 'vuex';
import DirectDebit from '@/components/Organisations/Billing/DirectDebit';
import Card from '@/components/Organisations/Billing/Card';
import CardLoadingSkeleton from './CardLoadingSkeleton';
import AddPaymentMethodCard from './AddPaymentMethodCard';
import AddPaymentProfileDialog from './AddPaymentProfileDialog';
import DefaultPaymentProfileConfirmDialog from './DefaultPaymentProfileConfirmDialog';
export default {
  name: 'payment-profiles',
  props: ['canManage', 'currentOrgId'],
  components: {
    DirectDebit,
    Card,
    CardLoadingSkeleton,
    AddPaymentMethodCard,
    AddPaymentProfileDialog,
    DefaultPaymentProfileConfirmDialog
  },
  data() {
    return {
      dialogState: false,
      paymentProfiles: [],
      totalPaymentProfiles: 0,
      loadingPaymentProfiles: true,
      confirmDialogState: false,
      cardId: '',
      dataTestId:'payment-card-information'
    };
  },
  computed: {
    ...mapState({
      defaultPaymentProfile: state => state.subscriptions?.paymentMode?.id || ''
    })
  },
  mounted() {
    this.getPaymentProfiles();
  },
  watch: {
    currentOrgId: function() {
      this.getPaymentProfiles();
    }
  },
  methods: {
    toggleAddPaymentProfileDialog(state) {
      this.dialogState = state || !this.dialogState;
    },
    toggleConfirmDialog(cardId, dialogState) {
      this.confirmDialogState = dialogState || !this.confirmDialogState;
      this.cardId = cardId;
    },
    async getPaymentProfiles() {
      try {
        const paymentProfilesData = await this.$services.billing.paymentProfiles(
          {
            page: 1,
            pageSize: 10
          }
        );
        const paymentProfiles = this.parseResponse(paymentProfilesData);
        if (paymentProfiles) {
          this.paymentProfiles = paymentProfiles[0];
          this.totalPaymentProfiles = this.paymentProfiles.length || 0;
        }
      } catch (err) {
        this.snackbar('error', err);
      }
      this.loadingPaymentProfiles = false;
    }
  }
};
</script>
<style scoped>
.payment-profiles-container {
  display: grid;
  grid-template-columns: repeat(auto-fill, 240px);
}
.payment-card-img {
  width: 40px;
  border: 1px solid #ccc;
  border-radius: 2px;
  aspect-ratio: 3/2;
  padding: 2px 0;
}
.payment-profile {
  padding: 16px;
  border: 1px solid #eee;
  border-radius: 4px;
}
p {
  margin: 0px;
}
.card-active {
  border: 1px solid #58e2c2;
  border-radius: 8px;
  padding: 1px 3px;
}
</style>
